import type { ReactNode } from 'react';

interface SegmentOption {
  value: string;
  label: string;
  icon?: ReactNode;
}

interface SegmentControlProps {
  options: SegmentOption[];
  value: string;
  onChange: (value: string) => void;
}

export default function SegmentControl({
  options,
  value,
  onChange,
}: SegmentControlProps) {
  return (
    <div className="inline-flex items-center gap-1 rounded-full bg-gray-100 p-1 dark:bg-gray-800">
      {options.map((option) => {
        const isActive = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium transition-colors duration-150 cursor-pointer ${
              isActive
                ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm'
                : 'text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200'
            }`}
          >
            {option.icon && <span className="shrink-0">{option.icon}</span>}
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
